import { render, staticRenderFns } from "./display-loading.vue?vue&type=template&id=2645f69f&"
import script from "./display-loading.vue?vue&type=script&lang=js&"
export * from "./display-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports